import { defineStore, acceptHMRUpdate } from 'pinia';
import { useStorage } from '@vueuse/core';
// useStorage('oneRater',
// import dayjs from "dayjs";
// import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
// dayjs.extend(isSameOrBefore);
import useDate from '@/composables/useDate';
import { v4 as uuidv4 } from 'uuid';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
// import router from '@/router';
import initialState from './initials/initialState';
import magnumInitialState from './initials/magnumInitialState';
import prepearFormFields from '@/utils/format/prepearFormFields.js';
import { sanitizeZipcode } from '@/utils/helpers';
const mode = import.meta.env.MODE;

const { dayjs, dataChecher, isBeforeDate } = useDate();

const toLowerCase = (item, key) => {
  if (!item[key]) {
    return item;
  }
  const newVal = [...item[key]].map(el => el.toLowerCase());
  item[key] = newVal.join('');
  return item;
};

const toStringMutator = (item, key) => {
  if (!item[key]) {
    return item;
  }
  item[key] = String(item[key]);
  return item;
};

const changeDateFormat = (item, key) => {
  item[key] = item[key] ? dayjs(item[key]).format('MM/DD/YYYY') : item[key];
  return item;
};

const changeDateFormatRequest = (item, key) => {
  if (key === 'contract_start_date') {
    item[key] = dataChecher(item[key]);
  }
  item[key] = item?.[key] ? dayjs(item[key]).format('YYYY-MM-DD') : null;
  return item;
};

const PRIMARY_DRIVER_APPLICANT_FIELDS = [
  'first_name',
  'middle_name',
  'last_name',
  'dob',
  'occupation',
  'gender',
  'married',
  'sr_22',
];

const normalizeDriver = driver => {
  if (!driver) return driver;

  const validTickets = Array.isArray(driver.tickets)
    ? driver.tickets.filter(ticket => ticket?.type && ticket?.date && ticket?.state)
    : [];
  const any_tickets = validTickets.length > 0;

  return {
    ...driver,
    any_tickets,
    tickets: any_tickets ? validTickets : [],
  };
};

const syncPrimaryDriverToApplicant = (applicant, primaryDriver) => {
  const patch = {};

  PRIMARY_DRIVER_APPLICANT_FIELDS.forEach(key => {
    if (Object.hasOwnProperty.call(primaryDriver, key)) {
      patch[key] = primaryDriver[key];
    }
  });

  return prepearFormFields(applicant, patch);
};

const formatDriversForRequest = drivers => {
  return (drivers || []).map(driver => {
    const normalized = normalizeDriver(cloneDeep(driver));
    const withDob = changeDateFormatRequest({ ...normalized }, 'dob');
    const { license, tickets, ...rest } = withDob;
    const ticketsDataFormat = Array.isArray(tickets)
      ? tickets.map(ticket => changeDateFormatRequest({ ...ticket }, 'date'))
      : [];
    const any_tickets = ticketsDataFormat.length > 0;

    return {
      ...rest,
      any_tickets,
      tickets: ticketsDataFormat.length ? ticketsDataFormat : null,
      license: changeDateFormatRequest({ ...license }, 'expiration'),
    };
  });
};

const oneRater = defineStore('oneRater', {
  state: () => ({
    magnum: {
      steps: {
        applicant: {
          valid: false,
          data: {
            first_name: '',
            middle_name: '',
            last_name: '',
            dob: '',
            occupation: '',
            gender: '',
            married: '',
            sr_22: false,
            address: '',
            apt: '',
            city: '',
            state: '',
            county: '',
            zipcode: '',
            email: '',
            phone: '',
            term: 6,
            contract_start_date: '',
            rent_own: 'OWNED',
            is_other_insurance: false,
            employer_zipcode: null,
            is_employer_zipcode: false,
            other_insurance: {
              company: 'OTHER',
              terms: '',
            },
          },
        },
        vehicles: {
          valid: false,
          car: {
            car_vin: '',
            car_make: '',
            car_model: '',
            car_year: '',
            car_lease: '',
            use_type: '',
            coverages: {
              BI: '25000-50000',
              UM: '25000-50000',
              PD: '20000',
              MEDPM: '1000',
            },
          },
          coveredges_plan: 'minimum',

          data: [],
        },

        drivers: {
          driver_count: '',
          driver: {
            first_name: '',
            middle_name: '',
            last_name: '',
            dob: '',
            occupation: '',
            gender: '',
            married: '',
            sr_22: '',
            // auto_dvantage: "on",
            any_tickets: false,
            relation_with_holder: '',
            dl_state: null,
            dl_number: null,
            dl_exp: null,
            license_status: null,
            tickets: [],
          },
          data: [],
        },
        quote: {
          details: null,
          socket_id: null,
          isCompare: false,
          checkAmount: false,
          updateQuoteLoader: false,
          finalPageLoader: false,
          isSelectPlan: false,
          isQuestionRequest: false,
          payment_data: {
            basic: null,
            recommend: null,
          },
          basic: {
            response: null,
            payment_info: null,
            stripe_intent: null,
          },
          addons_amount: null,
          total_premium: '232',
          response: null,
          phone: '',
          isVerify: false,
          eSign: false,
          docuSign: {
            esign_url: '',
          },
          plan: null,
          payment_info: null,
          stripe_intent: null,
          payment_plan: 'monthly',
          answers: {
            answered: false,
            data: [],
          },
          getQuoteError: null,
          type: 'basic',
          custom: false,
        },
        contract: {},
        final: {},
        // buy: {},
        contract_payment: [],
        payment: {},
      },
      providers: [],
      tmp_addons: [],
      quoteAddons: {
        cars: [],
        drivers: [],
      },
      addons: [],
      addonsList: [],
      isAuth: false,
      carsMake: [],
      carsModel: [],
      occupations: [],
      states: [],
      zipcode: '',
      timeStamp: '',
      dataLayer: [],
      isChooseContract: false,
      socketLoadingStatus: true,
      is_impersonating: false,
      docuSignIsCompleted: false,
      alert_fee_message: null,
      newsletter: true,
      fullCoverages: false,
      avalibleMfs: true,
    },
  }),
  // hydrate(storeState) {
  //   storeState.magnum = useStorage('oneRater');
  // },
  getters: {
    isSocketLoading: store => {
      if (!store.magnum.avalibleMfs) {
        return !!store.magnum.steps?.contract?.id;
      }
      return !!store.magnum.steps.contract?.payment?.id;
    },
    getDataLayer: store => store.magnum.dataLayer,
    getMfsAvalible: store => store.magnum.avalibleMfs,
    GET_IMPERSONATING: store => store.magnum.is_impersonating,
    GET_LOGIN_TOKEN: store => store.magnum.login_token,
    GET_FEE_TEXT: store => store.magnum?.alert_fee_message || '',
    GET_QUOTE_SOCKET_ERRORS: store => store.magnum.steps.quote.getQuoteError || null,
    getFinalLoader: store => !store.magnum.steps?.final?.QUOTE?.id,
    GET_DOCUSIGN_DOCUMENT_COMPLETED: store => store.magnum.docuSignIsCompleted,
    GET_FINAL_DATA: store => payload => {
      return store.magnum.steps.final[payload];
    },
    GET_FINAL_CONTRACT_ID: store => {
      return store.magnum.steps.final?.CONTRACT?.id || null;
    },
    GET_FINAL_DOCUSIGN_VALIDATION: store => {
      return store.magnum.steps.final?.CONTRACT?.provider_id == 5 || false;
    },
    GET_FINANCE_QUOTE: store => {
      const contract = store.magnum.steps.contract?.payment;
      return contract?.provider_id === 8 || false;
    },
    GET_PROVIDER_ID: store => {
      const contract = store.magnum.steps.contract;
      return contract.provider_id || 1;
    },
    GET_DOCUSIGN_VALIDATION: store => {
      const contract = store.magnum.steps.contract;
      const providerId = contract?.provider_id || 1;
      return providerId == 5;
    },
    getActionQuoteSelectPlan: store => store.magnum.steps.quote.isSelectPlan,
    getCompare: store => store.magnum.steps.quote.isCompare,
    GET_TERM: store => {
      const term = store.magnum.steps.applicant.data.term;
      const enableSr22 = store.magnum.steps.drivers.data?.filter(el => el.sr_22) || false;
      if (enableSr22.length) {
        return 12;
      }
      return term;
    },
    HIDE_ADDONS: store => {
      const state = store.magnum.steps.applicant.data.state;

      return state ? state == 'NM' : true;
    },
    GET_CHECK_AMOUNT: store => store.magnum.steps.quote.checkAmount,
    GET_UPDATE_LOADING: store => store.magnum.steps.quote.updateQuoteLoader,
    GET_STATES: store => store.magnum.states,
    GET_CARS_MAKE: store => store.magnum.carsMake,
    GET_CARS_MODEL: store => store.magnum.carsModel,
    GET_OCCUPATION: store => store.magnum.occupations,
    GET_STEPS: store => store.magnum.steps,
    GET_STEP: store => step => store.magnum.steps[step],
    GET_VALID: store => step => store.magnum.steps[step]?.valid,
    GET_VALID_STEP_ROUTE: store => step => {
      const steps = {
        'insurance.applicant': 'applicant',
        'insurance.vehicles': 'vehicles',
        'insurance.drivers': 'drivers',
      };
      return store.magnum.steps[steps[step]]?.valid;
    },
    GET_CARS: store => store.magnum.steps.vehicles.data,
    GET_CARS_COVEREDGER: store => store.magnum.steps.vehicles.coveredges_plan,
    GET_CARS_COVEREDGES: store => store.magnum.steps.vehicles.coveredges,
    GET_CAR: store => vin => store.magnum.steps.vehicles.cars.find(car => car.car_vin === vin),
    GET_DRIVERS: store => store.magnum.steps.drivers.data,
    GET_PARENT_DRIVERS: store => store.magnum.steps.drivers.data[0],
    GET_PHONE: store => store.magnum.steps.quote,
    GET_ESIGN_LINK: store => store.magnum.steps.quote.docuSign,
    GET_ESIGN_STATUS: store => store.magnum.steps.quote.eSign,
    GET_APPLICANT_PHONE: store => store.magnum.steps.applicant.data.phone,
    GET_APPLICANT: store => store.magnum.steps.applicant.data,
    GET_SR22: store => store.magnum.steps.applicant.data?.sr_22,
    GET_SR22_GLOBAL: store => {
      const applicant = store.magnum.steps.applicant.data?.sr_22;
      const drivers = store.magnum.steps.drivers.data.filter(el => el.sr_22);
      return applicant || !!drivers?.length;
    },
    GET_ANSWERS: store => store.magnum.steps.quote.answers,
    GET_QUESTIONS: store => {
      const contract = store.magnum.steps.contract;
      return contract?.additional?.answers || [];
    },
    GET_ANSWERED: store => {
      const contract = store.magnum.steps.contract;
      return contract?.additional?.answered || false;
    },
    GET_ZIP: store => store.magnum.zipcode,
    GET_CONTRACT_DATA: store => store.magnum.steps.contract,
    GET_CONTRACT_PAYMENT: store => store.magnum.steps.contract_payment,
    GET_CONTRACTS: store => store.magnum.steps.contract,
    GET_QUOTE: store => store.magnum.steps.quote,
    GET_QUOTE_CUSTOM_FLAG: store => store.magnum.steps.quote?.custom || false,
    GET_RATER_FEE: store => {
      const contract = store.magnum.steps.contract;
      return +(contract?.payment?.related?.additional?.rater_fee || 0);
    },
    GET_CONTRACT_SIMPLE: store => {
      const contract = store.magnum.steps.contract;
      const raterFee = +(contract?.payment?.related?.additional?.rater_fee || 0);
      const payment_info = {
        full: {
          total_addons_sum:
            +contract?.amount + +(store.magnum.steps.quote?.addons_amount || 0) || 0,
          total_sum: +contract?.amount || 0,
          raterFee,
        },
        monthly: {
          duration: +contract?.payment?.additional?.number_of_payments || 0,
          total_sum: contract?.payment?.amount || 0,
          monthly_sum: contract?.payment?.additional?.monthly_payment || 0,
          today_sum: contract?.payment?.additional?.down_payment || 0,
          raterFee,
        },
      };
      return {
        contract: contract,
        payment_info: payment_info,
      };
    },
    GET_QUOTE_CALCULATE: store => {
      const contract = store.magnum.steps.contract;
      const plan = store.magnum.steps.quote.payment_plan;

      const raterFee = +(contract?.payment?.related?.additional?.rater_fee || 0);
      const premiumSum = +(contract?.amount || 0);
      const addonSum = +(store.magnum.steps?.quote?.addons_amount || 0);
      const premiumAddonSum = premiumSum + addonSum || 0;
      const monthlySum = +(contract?.payment?.additional?.monthly_payment || 0);
      const monthlyDuration = +(contract?.payment?.additional?.number_of_payments || 0);
      const downPayment = +(contract?.payment?.additional?.down_payment || 0);
      const saveSum = monthlySum * monthlyDuration + downPayment - premiumAddonSum || 0;

      if (mode == 'development' || mode == 'staging') {
        console.table('calculate', {
          plan,
          raterFee,
          premiumSum,
          addonSum,
          premiumAddonSum,
          monthlySum,
          monthlyDuration,
          downPayment,
          saveSum,
        });
      }

      if (plan == 'monthly') {
        return {
          amount: +downPayment + raterFee || 0, //down_payment
          monthly_sum: +monthlySum || 0,
          duration: +monthlyDuration || 0,
          save_sum: saveSum,
        };
      } else {
        return {
          amount: premiumAddonSum + raterFee,
          monthly_sum: 0,
          duration: 0,
          save_sum: saveSum,
        };
      }
    },
    GET_QUOTE_CARS: store => {
      const contract = store.magnum.steps.contract;
      const cars = store.magnum.steps.vehicles.data;

      return cars.map(car => {
        return {
          ...car,
          coverages: contract?.additional?.coverages[car.uuid] || {},
        };
      });
    },
    GET_QUOTE_TYPE: store => store.magnum.steps.quote?.type,
    GET_QUOTE_PAYMENT_PLAN: store => store.magnum.steps.quote.payment_plan,
    GET_PAYMENT: store => store.magnum.steps.payment,
    GOOGLE_USER_INFO: store => {
      const userInfo = store.magnum.steps.applicant.data;
      return {
        email: userInfo.email,
        phone: userInfo.phone,
        first: userInfo.first_name,
        last: userInfo.last_name,
        street: userInfo.address,
        city: userInfo.city,
        region: userInfo.county,
        zipcode: userInfo.zipcode,
        state: userInfo.state,
      };
    },
    GET_CONNECT_ID: store => store.magnum.steps.quote?.socket_id || null,
    GET_CONTACT_ALERT_STATUS: store => store.magnum.steps.contract?.alert || false,
    GET_GOOGLE_ADDONS: store => {
      const drivers = cloneDeep(store.magnum.steps.drivers.data || []);
      const vehicles = cloneDeep(store.magnum.steps.vehicles.data) || [];
      const allAddonsData = store.magnum.quoteAddons || { drivers: [], cars: [] };

      // Collect all addon IDs from drivers and vehicles
      const driverAddonIds = drivers.flatMap(d => d?.addons || []);
      const vehicleAddonIds = vehicles.flatMap(v => v?.addons || []);

      // Get addon details from quoteAddons by matching ID
      const getAddonsByIds = (addonIds, addonsList) => {
        return addonIds.map(id => addonsList.find(addon => addon?.id === id)).filter(Boolean);
      };

      const driversAddons = getAddonsByIds(driverAddonIds, allAddonsData.drivers);
      const vehiclesAddons = getAddonsByIds(vehicleAddonIds, allAddonsData.cars);

      // Count how many times each addon product appears across all drivers/vehicles
      const countAddonsByProductId = addons => {
        const addonMap = new Map();
        addons.forEach(addon => {
          const productId = addon?.productable?.id;
          if (productId) {
            addonMap.set(productId, (addonMap.get(productId) || 0) + 1);
          }
        });
        return addonMap;
      };

      const driversAddonCount = countAddonsByProductId(driversAddons);
      const vehiclesAddonCount = countAddonsByProductId(vehiclesAddons);

      // Format addons: remove duplicates but keep quantity count
      const formatAddons = (addons, addonCountMap) => {
        const seenProductIds = new Set();
        return addons
          .filter(addon => {
            const productId = addon?.productable?.id;
            if (seenProductIds.has(productId)) return false;
            seenProductIds.add(productId);
            return true;
          })
          .map(addon => ({
            id: addon?.productable?.id,
            item_id: addon?.productable?.id,
            name: addon?.productable?.name,
            price: addon?.productable?.amount,
            quantity: addonCountMap.get(addon?.productable?.id) || 1,
          }));
      };

      return [
        ...formatAddons(driversAddons, driversAddonCount),
        ...formatAddons(vehiclesAddons, vehiclesAddonCount),
      ];
    },
    GET_ALL_STEPS: store => {
      let applicant = cloneDeep(store.magnum.steps.applicant.data);
      applicant = changeDateFormatRequest(applicant, 'dob');
      applicant = toLowerCase(applicant, 'email');
      applicant = sanitizeZipcode(applicant, 'zipcode');

      applicant = changeDateFormatRequest(applicant, 'contract_start_date');
      if (applicant.state != 'NM') {
        const { employer_zipcode, is_employer_zipcode, ...rest } = applicant;
        applicant = rest;
      }
      const drivers = formatDriversForRequest(store.magnum.steps.drivers.data);

      let vehicles = cloneDeep(store.magnum.steps.vehicles.data);
      vehicles = vehicles
        .map(({ coverages, ...vah }) => ({
          ...vah,
          coverages: null,
        }))
        .map(v => toStringMutator(v, 'year'));
      const enableSr22 = drivers?.filter(el => el.sr_22) || false;
      if (enableSr22?.length) {
        applicant.term = 12;
      }
      return {
        ...applicant,
        vehicles: vehicles,
        drivers: drivers,
        addons: [],
      };
    },
    GET_ALL_STEPS_UPDATE: store => {
      let applicant = cloneDeep(store.magnum.steps.applicant.data);
      applicant = toLowerCase(applicant, 'email');
      applicant = changeDateFormatRequest(applicant, 'dob');
      applicant = changeDateFormatRequest(applicant, 'contract_start_date');
      applicant = sanitizeZipcode(applicant, 'zipcode');
      if (applicant.state != 'NM') {
        const { employer_zipcode, is_employer_zipcode, ...rest } = applicant;
        applicant = rest;
      }
      const drivers = formatDriversForRequest(store.magnum.steps.drivers.data);
      const vehicles = cloneDeep(store.magnum.steps.vehicles.data);
      const enableSr22 = drivers?.filter(el => el.sr_22) || false;
      if (enableSr22?.length) {
        applicant.term = 12;
      }
      return {
        ...applicant,
        vehicles: vehicles.map(v => toStringMutator(v, 'year')),
        drivers: drivers,
        addons: [],
      };
    },
    GET_UPDATE_AND_RATE: store => {
      let applicant = cloneDeep(store.magnum.steps.applicant.data);
      applicant = changeDateFormatRequest(applicant, 'dob');
      applicant = toLowerCase(applicant, 'email');
      applicant = changeDateFormatRequest(applicant, 'contract_start_date');
      applicant = sanitizeZipcode(applicant, 'zipcode');
      if (applicant.state != 'NM') {
        const { employer_zipcode, is_employer_zipcode, ...rest } = applicant;
        applicant = rest;
      }
      const drivers = formatDriversForRequest(store.magnum.steps.drivers.data);
      const vehicles = cloneDeep(store.magnum.steps.vehicles.data);
      const enableSr22 = drivers?.filter(el => el.sr_22) || false;
      if (enableSr22?.length) {
        applicant.term = 12;
      }
      return {
        ...applicant,
        vehicles: vehicles.map(v => toStringMutator(v, 'year')),
        drivers: drivers,
        addons: [],
      };
    },
    GET_UPDATE_QUOTE_QUESTIONS: store => {
      return {
        answers: store.magnum.steps.contract?.additional?.answers,
      };
    },
    GET_RECOMENDED_COVERAGES: store => {
      const contract = store.magnum.steps.contract;
      return contract?.additional?.coverages || {};
    },
    GET_CHANGE_PRICE_STATUS: store => {
      return store.magnum.steps.contract?.additional?.checkAmount || false;
    },
    GET_QUOTE_COVERAGES: store => {
      const quote = store.magnum.steps.contract;
      return quote?.additional?.coverages || {};
    },
    GET_QUOTE_ADDONS: store => {
      return store.magnum.quoteAddons;
    },
    GET_RECOMENDED_ID: store => {
      return store.magnum.steps.contract?.id;
    },
    GET_ADDONS_AMOUNT: store => {
      return +(store.magnum.steps.quote?.addons_amount || 0);
    },
    GET_PAYMENT_AMOUNT: store => {
      const payment_plan = store.magnum.steps.quote.payment_plan;
      const quoteId = store.magnum.steps.contract;
      const raterFee = +(
        quoteId?.additional?.rater_fee ||
        quoteId?.finance_quote?.additional?.rater_fee ||
        0
      );
      const quoteAmount = +(payment_plan == 'full'
        ? quoteId?.amount
        : quoteId?.payment?.additional?.down_payment);
      const addonAmount = +(store.magnum.steps.quote?.addons_amount || 0);
      const amount =
        payment_plan == 'full' ? quoteAmount + addonAmount + raterFee : quoteAmount + raterFee;
      return Number(amount).toFixed(2);
    },
    GET_USER_FOR_REGISTRATION: store => store.magnum.steps.applicant.data,
    getFirstVisitTime: store => store.magnum.timeStamp,

    GET_ADDON_IDS: store => (Array.isArray(store.magnum.tmp_addons) ? store.magnum.tmp_addons : []),
    idAddonsUpdated: store => {
      const tmp = Array.isArray(store.magnum.tmp_addons) ? store.magnum.tmp_addons : [];
      const selected = Array.isArray(store.magnum.addons) ? store.magnum.addons : [];
      return isEqual(selected.sort(), tmp.sort());
    },
    GET_ADDON_TOTAL_AMOUNT: store => {
      const carsCount = Array.isArray(store.magnum.steps.vehicles.data)
        ? store.magnum.steps.vehicles.data?.length
        : 1;
      const ids = Array.isArray(store.magnum.addons) ? store.magnum.addons : [];
      const list = Array.isArray(store.magnum.addonsList) ? store.magnum.addonsList : [];
      const selected = list.filter(item => ids.includes(item.id));

      const carsAmount = selected
        .filter(item => item?.productable?.vehicle)
        .reduce((acc, item) => {
          return acc + +item?.productable?.amount;
        }, 0);
      const applicantAmount = selected
        .filter(item => !item?.productable?.vehicle)
        .reduce((acc, item) => {
          return acc + +item?.productable?.amount;
        }, 0);

      return carsAmount * carsCount + applicantAmount;
    },
    GET_ADDON_TEMPORY_AMOUNT: store => {
      const carsCount = Array.isArray(store.magnum.steps.vehicles.data)
        ? store.magnum.steps.vehicles.data?.length
        : 1;
      const ids = Array.isArray(store.magnum.tmp_addons) ? store.magnum.tmp_addons : [];
      const list = Array.isArray(store.magnum.addonsList) ? store.magnum.addonsList : [];
      const selected = list.filter(item => ids.includes(item.id));

      const carsAmount = selected
        .filter(item => item?.productable?.vehicle)
        .reduce((acc, item) => {
          return acc + +item?.productable?.amount;
        }, 0);
      const applicantAmount = selected
        .filter(item => !item?.productable?.vehicle)
        .reduce((acc, item) => {
          return acc + +item?.productable?.amount;
        }, 0);
      return carsAmount * carsCount + applicantAmount;
    },
  },
  actions: {
    SET_MFS_AVALIBLE_STATE(payload = false) {
      this.$patch(state => {
        state.magnum.avalibleMfs = payload;
        return state;
      });
    },
    SET_NEWSLETTER(payload = false) {
      this.$patch(state => {
        state.magnum.newsletter = payload;
        return state;
      });
    },
    SET_FULL_COVERAGES(payload = false) {
      this.$patch(state => {
        state.magnum.fullCoverages = payload;
        return state;
      });
    },
    SET_PROVIDES(payload = false) {
      this.$patch(state => {
        state.magnum.providers = payload;
        return state;
      });
    },
    SET_FINAL_LOADER(payload = false) {
      this.$patch(state => {
        state.magnum.steps.quote.finalPageLoader = payload;
        return state;
      });
    },
    setDataLayer(payload) {
      this.$patch(state => {
        state.magnum.dataLayer = payload;
        return state;
      });
    },
    SET_CONTRACT_ADDON_AMOUNT(payload) {
      this.$patch(state => {
        state.magnum.steps.quote.addons_amount = payload;
        return state;
      });
    },
    SET_CONTRACT_DATA(payload) {
      this.$patch(state => {
        state.magnum.steps.contract = payload;
        state.magnum.steps.quote.isSelectPlan = false;
        if (!state.magnum.avalibleMfs) {
          state.magnum.steps.quote.updateQuoteLoader = false;
        }
        return state;
      });
    },
    UPDATE_FORM_COVERAGES_INFO(payload) {
      this.$patch(state => {
        const newCoverages =
          payload?.related?.additional?.coverages || payload?.additional?.coverages;
        if (!newCoverages) return state;
        const oldCars = state.magnum.steps.vehicles.data;
        state.magnum.steps.vehicles.data = oldCars.map(el => {
          return {
            ...el,
            coverages: newCoverages[el.uuid] || el.coverages,
          };
        });

        return state;
      });
    },
    UPDATE_FORM_ADDONS_INFO(payload) {
      this.$patch(state => {
        const newCars =
          payload?.related?.contact?.details?.vehicles || payload?.contact?.details?.vehicles;
        if (!newCars) return state;
        const newDriver =
          payload?.related?.contact?.details?.drivers || payload?.contact?.details?.drivers;
        const oldCars = state.magnum.steps.vehicles.data;
        const oldDriver = state.magnum.steps.drivers.data;
        state.magnum.steps.vehicles.data = oldCars.map((el, $index) => {
          const addons = newCars[$index]?.addons;
          return {
            ...el,
            addons: addons,
          };
        });
        state.magnum.steps.drivers.data = oldDriver.map((el, $index) => {
          const addons = newDriver[$index]?.addons || [];
          return {
            ...el,
            addons: addons,
          };
        });
        return state;
      });
    },
    UPDATE_FORM_ADDONS_TERM(payload = null) {
      this.$patch(state => {
        const oldCars = state.magnum.steps.vehicles.data;
        const oldDriver = state.magnum.steps.drivers.data;
        const currentTerm = payload ? payload : this.GET_SR22_GLOBAL ? 12 : 6;
        const addonsObj = state.magnum.quoteAddons;
        state.magnum.steps.vehicles.data = oldCars.map((el, $index) => {
          // const addons = newCars[$index].addons;
          const carrAddons = addonsObj.cars;
          const addons = Array.isArray(el.addons)
            ? el.addons.map(addonId => {
                const currentAddon = carrAddons.find(el => el.id === addonId);
                return currentAddon?.productable?.term == currentTerm
                  ? addonId
                  : currentAddon?.related_id;
              })
            : [];
          return {
            ...el,
            addons: addons,
          };
        });
        state.magnum.steps.drivers.data = oldDriver.map((el, $index) => {
          const driversAddons = addonsObj.drivers;
          const addons = Array.isArray(el.addons)
            ? el.addons.map(addonId => {
                const currentAddon = driversAddons.find(el => el.id === addonId);
                return currentAddon?.productable?.term == currentTerm
                  ? addonId
                  : currentAddon?.related_id;
              })
            : [];

          return {
            ...el,
            addons: addons,
          };
        });
        return state;
      });
    },
    SET_CONTRACT_DATA_UPDATE(payload) {
      this.$patch(state => {
        if (payload.alert) {
          this.UPDATE_FORM_COVERAGES_INFO(payload);
          state.magnum.steps.contract.alert = true;
          return state;
        }
        let answered = false;
        let checkAmount = false;
        const sendQuestionReq = cloneDeep(state.magnum.steps.quote.isQuestionRequest);
        const contracts = state.magnum.steps.contract;
        if (contracts.amount == payload.amount && contracts?.additional?.answered) {
          state.magnum.steps.quote.isCompare = true;
        } else {
          if (sendQuestionReq) {
            checkAmount = true;
          }
        }
        if (contracts?.additional?.answered) {
          answered = true;
        }

        state.magnum.steps.contract = {
          ...contracts,
          ...payload,
          payment: contracts.payment,
        };
        state.magnum.steps.contract.additional['answered'] = answered;
        state.magnum.steps.contract.additional['checkAmount'] = checkAmount;
        state.magnum.steps.quote.updateQuoteLoader = false;
        state.magnum.steps.quote.isQuestionRequest = false;
        this.UPDATE_FORM_ADDONS_INFO(payload);
        this.UPDATE_FORM_COVERAGES_INFO(payload);
        return state;
      });
    },
    SET_CONTRACT_PAYMENT(payload) {
      this.$patch(state => {
        const contracts = state.magnum.steps.contract;
        this.UPDATE_FORM_ADDONS_INFO(payload);
        this.UPDATE_FORM_COVERAGES_INFO(payload);
        state.magnum.steps.quote.updateQuoteLoader = false;
        state.magnum.steps.contract = { ...contracts, payment: payload };
        return state;
      });
    },
    SET_UPDATE_QUOTE_ERROR(payload = false) {
      this.$patch(state => {
        state.magnum.steps.quote.updateQuoteLoader = payload;
        //  if (state.magnum.fullCoverages) {
        //   state.magnum.fullCoverages = false;
        //  }
        return state;
      });
    },
    SET_GET_QUOTE_ERROR(payload) {
      this.$patch(state => {
        state.magnum.steps.quote.getQuoteError = payload;
        return state;
      });
    },

    SET_FINAL_INFORMATION(payload) {
      this.$patch(state => {
        if (payload.type == 'NSD') {
          if (!Array.isArray(state.magnum.steps.final[payload.type])) {
            state.magnum.steps.final[payload.type] = [];
          }
          state.magnum.steps.final[payload.type] = [
            ...state.magnum.steps.final[payload.type],
            payload.data,
          ];
          return state;
        }

        state.magnum.steps.final[payload.type] = payload.data;

        if (payload.type == 'QUOTE') {
          this.CLEAR_FORM_DATA();
          state.magnum.steps.quote.finalPageLoader = false;
        }

        return state;
      });
    },
    CLEAR_FINAL_INFORMATION() {
      this.$patch(state => {
        state.magnum.steps.final = {};
        state.magnum.steps.contract = [];
        return state;
      });
    },
    SET_APPLICANT(payload) {
      this.$patch(state => {
        state.magnum.timeStamp = dayjs();
        payload.sr_22 = !!payload.sr_22;

        if (!state.magnum.steps.applicant.valid) {
          state.magnum.steps.applicant.data = payload;
          state.magnum.steps.applicant.valid = true;
        } else {
          const applicantClone = cloneDeep(state.magnum.steps.applicant.data);
          // state.magnum.steps.applicant.data = {
          //   ...state.magnum.steps.applicant.data,
          //   ...payload,
          // };
          const newAppplicant = prepearFormFields(applicantClone, payload);

          if (!newAppplicant?.is_other_insurance) {
            newAppplicant.other_insurance = null;
          }
          if (!newAppplicant?.is_employer_zipcode) {
            newAppplicant.employer_zipcode = null;
          }
          if (payload?.employer_zipcode) {
            newAppplicant.employer_zipcode = newAppplicant.employer_zipcode;
          }
          state.magnum.steps.applicant.data = newAppplicant;
        }
        const sr22 = payload?.sr_22 ? payload.sr_22 : state.magnum.steps.applicant.data.sr_22;
        state.magnum.steps.applicant.data.term = sr22 ? 12 : 6;
        state.magnum.zipcode = String(payload?.zipcode);

        const driver = {
          any_tickets: false,
          tickets: [],
          relation_with_holder: '',
          middle_name: null,
          license: {
            state: null,
            number: null,
            expiration: null,
            status: null,
          },
          married: null,
          sr_22: null,
        };

        if (!state.magnum.steps.drivers.data?.length) {
          Object.keys(state.magnum.steps.drivers.driver).forEach(
            el =>
              (driver[el] =
                payload[el] || typeof payload[el] === 'boolean' ? payload[el] : driver[el])
          );
          driver['uuid'] = uuidv4();
          driver.license.state = payload?.state || null;
          state.magnum.steps.drivers.data.push(driver);
        } else {
          const parentDriver = state.magnum.steps.drivers.data[0];

          const initDl = {
            state: null,
            number: null,
            expiration: null,
            status: null,
          };

          if (parentDriver.sr_22 && !payload.sr_22) {
            parentDriver.license.status = null;
          }

          const newParent = {};

          Object.keys(parentDriver).forEach(el => {
            if (Object.hasOwnProperty.call(payload, el)) {
              newParent[el] = payload[el];
            } else {
              newParent[el] = parentDriver[el];
            }
          });

          if (!Object.hasOwnProperty.call(newParent, 'middle_name')) {
            newParent['middle_name'] = null;
          }
          state.magnum.steps.drivers.data[0] = newParent;
        }
        this.UPDATE_FORM_ADDONS_TERM();
        return state;
      });
    },
    SET_START_DATE(payload) {
      this.$patch(state => {
        state.magnum.steps.applicant.data.contract_start_date = payload;
        return state;
      });
    },
    SET_TERM(payload) {
      this.$patch(state => {
        state.magnum.steps.applicant.data.term = payload;
        // state.magnum.addons = []
        // state.magnum.tmp_addons = []
        return state;
      });
    },
    SET_CARS(payload) {
      this.$patch(state => {
        state.magnum.steps.vehicles.data = payload;
        state.magnum.steps.vehicles.valid = true;
        return state;
      });
    },
    SET_CAR_ITEM(payload) {
      this.$patch(state => {
        const cars = cloneDeep(state.magnum.steps.vehicles.data);
        const currentCarIndex = cars.findIndex(car => payload.uuid === car.uuid);
        // cars.splice(currentCarIndex, 1, payload.item)
        if (currentCarIndex > -1) {
          cars[currentCarIndex] = payload.item;
        }

        state.magnum.steps.vehicles.data = cars;

        return state;
      });
    },
    // SET_CARS_COVEREDGER(payload) {
    //   this.$patch((state) => {
    //     state.magnum.steps.vehicles.coveredges_plan = payload.plan
    //     state.magnum.steps.vehicles.coveredges = payload.coveredges
    //     return state
    //   })

    // },
    SET_DRIVERS(payload) {
      this.$patch(state => {
        const normalized = Array.isArray(payload) ? payload.map(normalizeDriver) : [];
        const enableSr22 = normalized.filter(el => el.sr_22) || false;
        state.magnum.steps.applicant.data.term = enableSr22?.length ? 12 : 6;

        if (normalized[0]) {
          state.magnum.steps.applicant.data = syncPrimaryDriverToApplicant(
            state.magnum.steps.applicant.data,
            normalized[0]
          );
        }

        state.magnum.steps.drivers.data = normalized;
        state.magnum.steps.drivers.valid = true;
        this.UPDATE_FORM_ADDONS_TERM();
        return state;
      });
    },
    SET_QUOTE_CUSTOM_FLAG(payload = false) {
      this.$patch(state => {
        state.magnum.steps.quote.custom = payload;
        return state;
      });
    },
    CHANGE_DRIVER(payload) {
      this.$patch(state => {
        const normalized = Array.isArray(payload) ? payload.map(normalizeDriver) : [];

        if (normalized[0]) {
          state.magnum.steps.applicant.data = syncPrimaryDriverToApplicant(
            state.magnum.steps.applicant.data,
            normalized[0]
          );
        }

        state.magnum.steps.drivers.data = normalized;
        state.magnum.steps.drivers.valid = true;
        return state;
      });
    },
    EDIT_CAR(payload) {
      this.$patch(state => {
        state.magnum.steps.vehicles.cars.push(payload);
        return state;
      });
    },
    // addons
    SET_QUOTE_CAR_ADDONS(payload) {
      this.$patch(state => {
        state.magnum.quoteAddons.cars = payload;
        return state;
      });
    },
    SET_QUOTE_DRIVERS_ADDONS(payload) {
      this.$patch(state => {
        state.magnum.quoteAddons.drivers = payload;
        return state;
      });
    },
    SET_ADDONS(payload) {
      this.$patch(state => {
        state.magnum.addonsList = payload;
        return state;
      });
    },
    SET_ADDONS_ID(payload) {
      this.$patch(state => {
        // if (payload == null) {
        //   state.magnum.addons = []
        //   return state
        // }
        const addons = state.magnum.tmp_addons;
        if (addons.includes(payload)) {
          const index = addons.findIndex(el => el == payload);
          state.magnum.tmp_addons = addons.filter(el => el != payload);
          return state;
        }
        state.magnum.tmp_addons = [...state.magnum.tmp_addons, payload];
        return state;
      });
    },
    SET_CURRENT_ADDON_ID() {
      this.$patch(state => {
        state.magnum.addons = state.magnum.tmp_addons;
        return state;
      });
    },
    SET_CURRENT_ADDON_ID_LOAD() {
      this.$patch(state => {
        state.magnum.tmp_addons = state.magnum.addons;
        return state;
      });
    },

    DELETE_CAR(payload) {
      this.$patch(state => {
        const newList = state.magnum.steps.vehicles.cars.filter(car => car.car_vin != payload);
        state.magnum.steps.vehicles.cars = newList;
        return state;
      });
    },

    SET_STATES(payload) {
      this.$patch(state => {
        state.magnum.states = payload;
        return state;
      });
    },

    SET_OCCUPATION(payload) {
      this.$patch(state => {
        state.magnum.occupations = payload;
        return state;
      });
    },
    SET_CARS_MAKE(payload) {
      this.$patch(state => {
        state.magnum.carsMake = payload;
        return state;
      });
    },
    SET_CARS_MODEL(payload) {
      this.$patch(state => {
        state.magnum.carsModel = payload;
        return state;
      });
    },
    SET_IMPERSONATING(payload = true) {
      this.$patch(state => {
        state.magnum.is_impersonating = payload;
        return state;
      });
    },
    SET_LOGIN_TOKEN(payload = null) {
      this.$patch(state => {
        state.magnum.login_token = payload;
        return state;
      });
    },
    CLEAR_LOGIN_TOKEN() {
      this.$patch(state => {
        state.magnum.login_token = null;
        return state;
      });
    },
    SET_FEE_TEXT(payload = true) {
      this.$patch(state => {
        state.magnum.alert_fee_message = payload;
        return state;
      });
    },
    SET_DOCUSIGN_DOCUMENT_COMPLETED(payload = false) {
      this.$patch(state => {
        state.magnum.docuSignIsCompleted = payload;
        return state;
      });
    },
    SET_PHONE(payload) {
      this.$patch(state => {
        state.magnum.steps.applicant.data.phone = payload;
        state.magnum.steps.quote.phone = payload;
        state.magnum.steps.quote.isVerify = true;
        return state;
      });
    },
    SET_ANSWERS(payload) {
      this.$patch(state => {
        state.magnum.steps.quote.answers.data = payload;
        state.magnum.steps.quote.answers.answered = true;
        return state;
      });
    },
    SET_ANSWERS_QUOTE(payload) {
      this.$patch(state => {
        state.magnum.steps.contract.additional.answers = payload;
        state.magnum.steps.contract.additional['answered'] = true;
        return state;
      });
    },
    SET_SOCKET_ID(payload) {
      this.$patch(state => {
        state.magnum.steps.quote.socket_id = payload;
        return state;
      });
    },
    SET_QUOTE(payload, flag = null) {
      this.$patch(state => {
        state.magnum.steps.quote.details = payload.details;
        state.magnum.steps.quote.socket_id = payload.id;

        if (!flag) {
          state.magnum.steps.contract = {};
          state.magnum.steps.contract_payment = {};
        }

        return state;
      });
    },
    SET_QUOTE_TYPE(payload) {
      this.$patch(state => {
        state.magnum.steps.quote['type'] = payload;
        return state;
      });
    },
    SET_QUESTION_FLAG(payload = false) {
      this.$patch(state => {
        state.magnum.steps.quote.isQuestionRequest = payload;
        return state;
      });
    },

    // SET_PAYMENT_DATA() {
    //   this.$patch((state) => {
    //     state.magnum.steps.quote.payment_data.basic = this.GET_CONTRACT_BASIC.payment_info || {}
    //     state.magnum.steps.quote.payment_data.recommend = this.GET_CONTRACT_RECOMMENDED.payment_info || {}
    //     state.magnum.steps.quote.isCompare = false
    //     state.magnum.steps.quote.updateQuoteLoader = true
    //     return state
    //   })
    // },
    CLEAR_SOCEKET_STATUS() {
      this.$patch(state => {
        state.magnum.steps.quote.isCompare = true;
        state.magnum.steps.quote.updateQuoteLoader = false;
        return state;
      });
    },
    UPDATE_SOCEKET_STATUS(payload = true) {
      this.$patch(state => {
        // state.magnum.steps.quote.isCompare = false
        state.magnum.steps.quote.updateQuoteLoader = payload;
        return state;
      });
    },
    SET_QUOTE_ACTION(payload = false) {
      this.$patch(state => {
        state.magnum.steps.quote.isSelectPlan = payload;
      });
    },
    SET_COMPARE(payload = false) {
      this.$patch(state => {
        state.magnum.steps.quote.isCompare = payload;
      });
    },
    SET_QUOTE_PLAN(payload) {
      this.$patch(state => {
        state.magnum.steps.quote.payment_plan = payload;
        return state;
      });
    },
    SAVE_ZIP(payload, rawData) {
      this.$patch(state => {
        const data = Array.isArray(rawData) ? rawData[0] : rawData;
        state.magnum.steps.applicant.data.county = data?.county || '';
        state.magnum.steps.applicant.data.city = data?.city || '';
        state.magnum.steps.applicant.data.state = data?.state || '';
        state.magnum.zipcode = typeof payload === 'string' ? payload.split('-')[0] : payload;
        return state;
      });
    },
    SAVE_NEW_EMAIL(payload) {
      this.$patch(state => {
        state.magnum.steps.payment.user.email = payload;
        return state;
      });
    },
    SET_ESIGN(payload) {
      this.$patch(state => {
        state.magnum.steps.quote.eSign = payload === 'true';
        return state;
      });
    },
    SET_ESIGN_DATA(payload) {
      this.$patch(state => {
        state.magnum.steps.quote.docuSign = payload;
        return state;
      });
    },
    SET_CHOICE_CONTRACT: (payload = true) => {
      this.$patch(state => {
        state.magnum.isChooseContract = payload;
        return state;
      });
    },
    CLEAR_STATE(reload = true) {
      this.$patch(state => {
        state.magnum = cloneDeep(magnumInitialState);
        localStorage.clear();
        if (reload) {
          window.location.reload();
        }

        return state;
      });
    },
    CLEAR_FORM_DATA() {
      this.$patch(state => {
        const final = state.magnum.steps.final;
        const addonsAmount = state.magnum.steps.quote?.addons_amount;
        state.magnum.steps = initialState;
        state.magnum.steps.final = final;
        state.magnum.steps.quote.addons_amount = addonsAmount;
        state.magnum.addons = [];
        state.magnum.tmp_addons = [];
        state.magnum.docuSignIsCompleted = false;
        return state;
      });
    },
    SET_PENDING_INFO(payload) {
      this.$patch(state => {
        // this.CLEAR_STATE(false)
        const { drivers, vehicles, answers, internal, ...applicant } = payload.details;
        applicant.sr_22 = drivers[0].sr_22 || false;
        const newApplicant = changeDateFormat(applicant, 'dob');
        if (!newApplicant?.other_insurance?.terms) {
          newApplicant['is_other_insurance'] = false;
          newApplicant['other_insurance'] = null;
        } else {
          newApplicant['is_other_insurance'] = true;
          newApplicant['other_insurance'] = cloneDeep(newApplicant?.other_insurance);
        }
        newApplicant.contract_start_date = changeDateFormat(
          { contract_start_date: dataChecher(newApplicant.contract_start_date) },
          'contract_start_date'
        ).contract_start_date;

        state.magnum.steps.applicant.valid = false;
        this.SET_APPLICANT(newApplicant);
        this.SET_DRIVERS(
          drivers
            .map(dr => changeDateFormat(dr, 'dob'))
            .map(dr => ({
              ...dr,
              license: changeDateFormat(dr.license, 'expiration'),
            }))
            .map(el => ({ ...el, tickets: [] }))
        );
        this.SET_CARS(
          vehicles.map(el => ({
            ...el,
            lien_holder: null,
          }))
        );
        if (payload?.insurance_quote) {
          const c = {
            payment: payload.insurance_quote?.finance_quote,
            ...(payload.insurance_quote?.contract || payload.insurance_quote),
          };
          this.UPDATE_FORM_COVERAGES_INFO(payload.insurance_quote);
          this.SET_CONTRACT_DATA(c);
        }

        this.SET_ANSWERS(answers);

        state.magnum.steps.quote.socket_id = payload?.id;
        return state;
      });
    },
  },
  persist: true,
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(oneRater, import.meta.hot));
}

export default oneRater;
